import axiosInstance from './axiosInstance'

export const getProjectSectionById = (sectionId) => {
  return axiosInstance.get(`/project/sections/${sectionId}`)
}

export const getProjectSections = () => {
  return axiosInstance.get('/project/sections')
}

export const getProjectSectionsWithTasks = (projectId) => {
  return axiosInstance.get(`/project/sections?projectId=${projectId}&withTasks=true`)
}

export const createProjectSection = (data) => {
  return axiosInstance.post('/project/sections', data)
}

export const updateProjectSection = (sectionId, data) => {
  return axiosInstance.put(`/project/sections/${sectionId}`, data)
}

export const deleteProjectSection = (sectionId) => {
  return axiosInstance.delete(`/project/sections/${sectionId}`)
}
